import { Container, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid";
import FullTimeSupportImage from "../../assets/all_time_support.png";
import BuysellImage from "../../assets/3400_buy_sell.png";
import UsersImage from "../../assets/all_users.png";
import GooglePlusImage from "../../assets/g+.png";
import TwitterImage from "../../assets/twitter_about_us.png";
import InstagramImage from "../../assets/instagram_aboutus.png";
import FacebookImage from "../../assets/fb_aboutus.png";
import { Link } from "react-router-dom";
import "./AboutUs.css";
import Info1Image from "../../assets/Info_about_us.png";
import Info2Image from "../../assets/Info_2_about_us.png";
import Info3Image from "../../assets/info_3_about_us.png";
import Info4Image from "../../assets/info_4_about_us.png";
import BitCoin2Image from "../../assets/bit_2_about_us.png";
import { useEffect } from "react";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "درباره ما";
  }, []);
  return (
    <Box>
      <Box
        sx={{
          background:
            "linear-gradient(180deg, rgba(15, 1, 27, 0.39) 0%, rgba(24, 0, 45, 0.44) 100%)",
        }}
      >
        <Box className="outer_box_header">
          <Container>
            <Stack
              direction={"row"}
              my={2}
              spacing={4}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <div
                style={{
                  background:
                    "linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)",
                  width: "130px",
                  height: "1px",
                }}
                className="border-solid-text"
              ></div>
              <Typography
                variant="h4"
                sx={{ textAlign: "center", color: "text.primary" }}
              >
                {t("more_about_rabsana")}
              </Typography>
              <div
                style={{
                  background:
                    "linear-gradient(90deg, #8E2DE2 0.33%, rgba(74, 0, 224, 0.51) 100.65%)",
                  transform: "rotate(-180deg)",
                  width: "130px",
                  height: "1px",
                }}
                className="border-solid-text"
              ></div>
            </Stack>
            <Typography
              variant="subtitle1"
              sx={{ textAlign: "center", color: "text.primary", my: 1.5 }}
            >
              پارسیان بیت صرافی با سابقه ایرانی با دارا بودن بیش از ۱۰۰۰
              ارزدیجیتال و ارز الکترونیک
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              sx={{ textAlign: "center", color: "text.primary", my: 1 }}
            >
              {/* {t("follow_us").slice(0, 150)} */}
            </Typography>
            {/* <Stack direction={"row"} spacing={2} justifyContent={"center"}>
              <Link to="/">
                <Box>
                  <img src={GooglePlusImage} alt="icon" width="100%" />
                </Box>
              </Link>
              <Link to="/">
                <Box>
                  <img src={TwitterImage} alt="icon" width="100%" />
                </Box>
              </Link>
              <Link to="/">
                <Box>
                  <img src={InstagramImage} alt="icon" width="100%" />
                </Box>
              </Link>
              <Link to="/">
                <Box>
                  <img src={FacebookImage} alt="icon" width="100%" />
                </Box>
              </Link>
            </Stack> */}
          </Container>
          <Box className="shape_bottom"></Box>
        </Box>
      </Box>
      <Box sx={{ bgcolor: "background.default", py: 2.5 }}>
        <Container>
          <Grid container>
            <Grid item xs={12} md={6}>
              <Grid container>
                <Grid
                  item
                  sx={{ p: 1.5, diplay: "flex", justifyContent: "center" }}
                  xs={12}
                  sm={6}
                >
                  <Box>
                    <img src={Info1Image} alt="icon" width="auto" />
                  </Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: "start", color: "text.primary", my: 1.5 }}
                  >
                    بیش از ۱۰۰۰ ارز دیجیتال
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    component="p"
                    sx={{
                      textAlign: "start",
                      color: "text.secondary",
                      my: 1.5,
                    }}
                  >
                    در پارسیان بیت شما میتوانید به بیش از ۱۰۰۰ ارزدیجتال دسترسی
                    داشته باشید
                  </Typography>
                </Grid>
                <Grid item sx={{ p: 1.5 }} xs={12} sm={6}>
                  <Box>
                    <img src={Info2Image} alt="icon" width="auto" />
                  </Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: "start", color: "text.primary", my: 1.5 }}
                  >
                    ارز های الکترونیک
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    component="p"
                    sx={{
                      textAlign: "start",
                      color: "text.secondary",
                      my: 1.5,
                    }}
                  >
                    پارسیان بیت به شما کمک میکند که به تمامی ارز های الکترونیک
                    دسترسی داشته باشید
                  </Typography>
                </Grid>
                <Grid item sx={{ p: 1.5 }} xs={12} sm={6}>
                  <Box>
                    <img src={Info3Image} alt="icon" width="auto" />
                  </Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: "start", color: "text.primary", my: 1.5 }}
                  >
                    پشتیبانی آنلاین
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    component="p"
                    sx={{
                      textAlign: "start",
                      color: "text.secondary",
                      my: 1.5,
                    }}
                  >
                    در پارسیان بیت شما به صورت ۲۴ ساعته از پشتیبانی آنلاین بهره
                    مند هستید
                  </Typography>
                </Grid>
                <Grid item sx={{ p: 1.5 }} xs={12} sm={6}>
                  <Box>
                    <img src={Info4Image} alt="icon" width="auto" />
                  </Box>
                  <Typography
                    variant="subtitle1"
                    sx={{ textAlign: "start", color: "text.primary", my: 1.5 }}
                  >
                    تعداد کاربران
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    component="p"
                    sx={{
                      textAlign: "start",
                      color: "text.secondary",
                      my: 1.5,
                    }}
                  >
                    پارسیان بیت با دارا بودن بیش از ۵۰۰۰ کاربر فعال یکی از مورد
                    اعتماد ترین صرافی های ایرانی است{" "}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{ justifyContent: "center", display: "flex" }}
            >
              <Box>
                <img src={BitCoin2Image} alt="icon" width="auto" />
              </Box>
            </Grid>
          </Grid>
          <Grid container sx={{ mt: 6, mb: 4 }} spacing={2}>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{
                px: 1.25,
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box>
                <img src={FullTimeSupportImage} alt="icon" width="auto" />
              </Box>
              <Typography
                variant="h4"
                sx={{ textAlign: "center", color: "text.primary", my: 1.5 }}
              >
                {t("support")}
              </Typography>
              <Typography
                variant="h6"
                component="p"
                sx={{ textAlign: "center", color: "text.secondary", my: 1.5 }}
              >
                به صورت ۲۴ ساعته ۷ روز هفته در خدمت شما هستیم
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{
                px: 1.25,
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box>
                <img src={BuysellImage} alt="icon" width="auto" />
              </Box>
              <Typography
                variant="h4"
                sx={{ textAlign: "center", color: "text.primary", my: 1.5 }}
              >
                خرید و فروش
              </Typography>
              <Typography
                variant="h6"
                component="p"
                sx={{ textAlign: "center", color: "text.secondary", my: 1.5 }}
              >
                معامله بیش از ۱۰۰۰ ارز دیجیتال در پارسیان بیت
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{
                px: 1.25,
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box>
                <img src={UsersImage} alt="icon" width="auto" />
              </Box>
              <Typography
                variant="h4"
                sx={{ textAlign: "center", color: "text.primary", my: 1.5 }}
              >
                {t("user")}
              </Typography>
              <Typography
                variant="h6"
                component="p"
                sx={{ textAlign: "center", color: "text.secondary", my: 1.5 }}
              >
                مورد اعتماد بیش از ۵۰۰۰ هزار کاربر{" "}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                justifyContent: { xs: "center", md: "start" },
                display: "flex",
              }}
            >
              <Box>
                <img src={BitCoin2Image} alt="icon" width="auto" />
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h5"
                sx={{ textAlign: "start", color: "text.primary", my: 1.5 }}
              >
                پارسیان بیت
              </Typography>
              <Typography
                variant="h6"
                component="p"
                sx={{ textAlign: "start", color: "text.secondary", my: 1.5 }}
              >
                ما در صرافی پارسیان بیت به صورت شبانه روزی در تلاش هستیم که با
                ارائه خدمات کامل به مشتریان خود مسیر ورود کاربران به دنیای
                دیجیتال را تسهیل کنیم.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default AboutUs;
